export type Capability<A extends any[], T = void> = string & {
  readonly __hack?: (...args: A) => T
}

export const defineCapability = <A extends any[], T = void>(name: string): Capability<A, T> => name

export type CapabilityHandler<C> = C extends Capability<infer A, infer T> ? (...args: A) => T : never
